import React, { Component } from 'react'
import Map from "ol/Map.js";
import View from "ol/View.js";
import "ol/ol.css";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import * as proj from "ol/proj";
import { defaults, FullScreen, ScaleLine } from "ol/control";
import mapConfig from "../config/mapConfig.json";
import LayerGroup from "ol/layer/Group";
import LayerSwitcher from "ol-layerswitcher";
import Layers from "../config/layers";
// import {getRenderPixel} from 'ol/render.js';
import Draggable from 'react-draggable';
import Accordion from 'react-bootstrap/Accordion';
import Select from 'ol/interaction/Select';
import Overlay from 'ol/Overlay';
import "../App.css"


const baseMaps = new LayerGroup({
  title: "Base maps",
  layers: [Layers.Bhuvan],
});


class BasicMap extends Component {
  constructor(props) {
    super(props);
    this.state = { center: proj.fromLonLat(mapConfig.center), zoom: mapConfig.zoomLevel,showLegend:false,colors:[]};
    
    this.map = new Map({
      target: null, // set this in componentDidMount
      layers: [baseMaps],
      //layers: [baseMaps, Layers.districtLayer],
      //controls: defaults().extend([new ScaleLine(), new FullScreen()]),
      view: new View({
        center: this.state.center,
        zoom: this.state.zoom,        
      }),
    });
    
    const layerSwitcher = new LayerSwitcher({
      reverse: true,
      groupSelectStyle: "group",
    });
    this.map.addControl(layerSwitcher)
    
    
  }
  
  componentDidMount() {
    // const divToCapture = document.getElementsByClassName('ol-layer')
    //           console.log(divToCapture)
    
    let temp
    let resCenter
    this.map.setTarget("map")
    // console.log("resdata",this.props.resData.length)
    if(this.props.resData && this.props.resData.length>0){      
      this.setState({colors:this.props.colors})
      // console.log("basicMap colcors",this.props.colors)
      temp=JSON.parse(this.props.resData)
      // console.log("ResData",temp[0].geometry.coordinates[0][0].length)
      {temp[0].geometry.coordinates[0][0].length==2?
      
      resCenter=temp[0].geometry.coordinates[0][0]
      :
      resCenter=temp[0].geometry.coordinates[0][0][0]
      }
      this.map.getView().setZoom(12);
      this.map.getView().setCenter(proj.fromLonLat(resCenter));
      this.map.addLayer(Layers.LULC)
      this.map.addLayer(this.props.results)
      // console.log("this.props.results.getExtent()",this.props.results.getSource().getExtent())
    //           const divToCapture = document.getElementsByClassName('ol-layer')
    //           console.log(divToCapture)
             
    //       html2canvas(divToCapture, {
    //         useCORS: true,
    //         allowTaint: true,
    //       })
    // .then((canvas) => {
    //   const base64Image = canvas.toDataURL('image/png');
    //   console.log('Base64 Image:', base64Image);
      
    // })
    // .catch((error) => {
    //   console.error('Error capturing div:', error);
    // });
   
      }
      
      const popup = new Overlay({
        element: document.getElementById("popup"),
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      });
      this.map.addOverlay(popup);
      const select = new Select({
        condition: (evt) => evt.type === 'pointermove',
        layers: [this.props.results],
      });

      select.on('select', (event) => {
        const selectedFeature = event.selected[0];
        if (selectedFeature) {
          const featureId = selectedFeature.getId();
          const coordinate = event.mapBrowserEvent.coordinate;
          popup.setPosition(coordinate);
          document.getElementById("popup").innerHTML = `<div>${featureId}</div>`;
        } else {
          popup.setPosition(undefined);
        }
      });
      this.map.addInteraction(select)

      
     
    // Listen to map changes
    //   this.map.on("moveend", () => {
    //   let center =resCenter
    //   let zoom = 12
    //   this.setState({ center:proj.fromLonLat(center), zoom:zoom })
    // });
   // console.log(this.props.results);
   
  }
  componentWillUnmount() {
    this.map.setTarget(null);    
  }

  render() {
    return (
      <>
       <div id="map" className="ol-map">
       <div id="popup" className="popup"></div>
       
      <Draggable>   
       <div style={{position:'absolute',right:20,bottom:10,backgroundColor:'#ffffff',padding:5,borderRadius:10,zIndex:1000,cursor:'move'}}>       
        <Accordion defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Legends</Accordion.Header>
          <Accordion.Body>
        <div style={{height:200,overflow:'auto'}}>
                  
        <h5 style={{color:'blue',fontWeight:'bold',textAlign:'center'}}>LRDP/WRDP Legends</h5>
        {this.props.resData.length>0 && this.state.colors.length>0 && this.state.colors.map((item,i)=>
        <div key={i} style={{}}>
          {Object.keys(item).map((key)=>(
            <div style={{display:'flex'}}>
            <div class='box red' style={{backgroundColor:item[key],marginBottom:-5,alignSelf:'center',marginRight:5}}>
              </div>
             <p style={{marginBottom:-5,fontSize:13,color:'#000000',alignSelf:'center'}} key={i}>{key}</p>
             </div>             
          ))}
         
        </div>
        )}
        <h5 style={{color:'blue',fontWeight:'bold',textAlign:'center',marginTop:15}}>LULC Legends</h5>
          <img src="https://bhuvanpanchayat.nrsc.gov.in/img/LULCLEGENDP2.jpg" />
          </div>
          </Accordion.Body>
      </Accordion.Item>
    </Accordion>
        
        </div>
        </Draggable>       
       </div>
      
       
      </>
    );
  }
}
export default BasicMap

